import { API_CONFIG } from '../config/api';

export interface ContactFormData {
  name: string;
  email: string;
  phone: string;
  message: string;
}

export interface ContactResponse {
  success: boolean;
  message: string;
  data?: {
    id: number;
    status: string;
  };
}

class ContactService {
  private baseURL = `${API_CONFIG.adminService}/api/admin`;

  async submitContactForm(formData: ContactFormData): Promise<ContactResponse> {
    try {
      const response = await fetch(`${this.baseURL}/contact`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to submit contact form');
      }

      return data;
    } catch (error) {
      console.error('Contact form submission error:', error);
      throw error;
    }
  }
}

const contactService = new ContactService();
export default contactService;
